<template>
  <SelectFolderModal
    ref="selectFolderModal"
    modal-id="feed-import-file-browser-modal"
    modal-title="Select Excel feed file"
    :view-tabs="false"
    :show-layouts="false"
    :is-light-weight="true"
    @onSelectedItems="handleSelectedItems"
  />
</template>

<script>
import SelectFolderModal from '@frontend/components/modules/file-browser/modals/SelectFolderModal.vue';

const OPEN_EVENT = 'feed-import-file-browser:open';
const SELECTED_EVENT = 'feed-import-file-browser:selected';
const ACCEPTED_FILE_REGEXP = /\.(xls|xlsx)$/i;

export default {
  name: 'FeedImportFileBrowserModal',
  components: {
    SelectFolderModal,
  },
  data() {
    return {
      shouldRestoreImportModal: false,
    };
  },
  mounted() {
    window.addEventListener(OPEN_EVENT, this.handleOpenModal);
    this.$root.$on('bv::modal::hidden', this.handleAnyModalHidden);
  },
  beforeDestroy() {
    window.removeEventListener(OPEN_EVENT, this.handleOpenModal);
    this.$root.$off('bv::modal::hidden', this.handleAnyModalHidden);
  },
  methods: {
    handleOpenModal() {
      const importModal = document.getElementById('ImportXlsModal');
      this.shouldRestoreImportModal = Boolean(importModal?.classList.contains('show'));

      if (this.shouldRestoreImportModal) {
        this.$bvModal.hide('ImportXlsModal');
      }

      this.$bvModal.show('feed-import-file-browser-modal');
      this.$nextTick(() => {
        const modalOuter = document.getElementById('feed-import-file-browser-modal___BV_modal_outer_');
        const backdrop = document.getElementById('feed-import-file-browser-modal___BV_modal_backdrop_');

        if (modalOuter) {
          modalOuter.style.zIndex = '1061';
        }

        if (backdrop) {
          backdrop.style.zIndex = '1060';
        }
      });
    },
    handleSelectedItems(items = []) {
      const excelItems = items.filter((item) => ACCEPTED_FILE_REGEXP.test(item?.original_path || ''));

      if (!excelItems.length) {
        toastr.error('Please select an XLS or XLSX file.');
        return;
      }

      if (excelItems.length > 1) {
        toastr.info('Multiple files were selected. Only the first Excel file will be used.');
      }

      window.dispatchEvent(new CustomEvent(SELECTED_EVENT, {
        detail: {
          item: excelItems[0],
          items: excelItems,
        },
      }));

      this.restoreImportModal();
    },
    handleAnyModalHidden(modalId) {
      if (modalId === 'feed-import-file-browser-modal') {
        this.restoreImportModal();
      }
    },
    restoreImportModal() {
      if (!this.shouldRestoreImportModal) {
        return;
      }

      this.shouldRestoreImportModal = false;
      this.$nextTick(() => {
        this.$bvModal.show('ImportXlsModal');
      });
    },
  },
};
</script>
